import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isExplicitLogonResourceMailboxInfo } from './isExplicitLogonResourceMailboxInfo';

export function shouldUseExplicitLogonAttachmentRouting(mailboxInfo: MailboxInfo): boolean {
    return (
        isGlobalFeatureEnabled('doc-explicit-logon-resource-attachment-routing') &&
        isExplicitLogonResourceMailboxInfo(mailboxInfo)
    );
}
